<div class="footer py-4 d-flex flex-lg-column shadow-none " id="kt_footer" [ngClass]="footerClasses" style="position: revert">
  <div [ngClass]="footerContainerClasses" class=" d-flex flex-column flex-md-row align-items-center justify-content-between">
    <div class="color-white order-2 order-md-1 m-auto font-weight-bold">
      <span class="mr-4">{{today | date:'yyyy'}} &copy;</span>
      <span (click)="openReleaseNotes()">v{{releaseVersion}}</span>
    </div>
  </div>
</div>
